<!--
 * @Description:成交客户
 * @Author: cxh
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-07-13 15:57:23
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        rowKey="cosId"
        :row-selection="{ onChange: onSelectChange }"
        serial
        :columns="columns"
        tableId="lbuClients"
        @fetch="fetch"
        v-model:search="queryForm"
        ref="tableRef"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item label="客户名称" :span="12">
              <a-textarea
                v-model:value="queryForm.customerName"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="客户代码" :span="12">
              <a-textarea
                v-model:value="queryForm.tmsCode"
                :autoSize="{ minRows: 1, maxRows: 4 }"
                placeholder="请输入"
              />
            </dc-form-item>
            <dc-form-item label="客户识别码">
              <a-input v-model:value="queryForm.customerSerial" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户ID">
              <a-input v-model:value="queryForm.cosId" :maxlength="500" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="路区代码">
              <a-input v-model:value="queryForm.roadAreaCode" :maxlength="500" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户阶段">
              <a-select
                v-model:value="queryForm.stageList"
                placeholder="请选择"
                allow-clear
                mode="multiple"
                :options="clueAndcustomerPhaseEnum"
              />
            </dc-form-item>
            <dc-form-item label="客户负责人">
              <UserSelect permission v-model:value="queryForm.sellerList" mode="multiple" />
            </dc-form-item>
            <dc-form-item label="客户区域">
              <CustomerAreaCascader type="search" appId="cos_lbu" v-model:ids="queryForm.customerRegionList" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="queryForm.channelList"
                  appId="cos_lbu"
                  paramCode="lbu_source_channel"
                  style="width: 33%"
                />
                <a-input
                  v-model:value="queryForm.channelExplain"
                  :maxlength="100"
                  style="width: 67%"
                  placeholder="请输入"
                />
              </a-input-group>
            </dc-form-item>
            <dc-form-item label="时间查询">
              <a-input-group compact>
                <a-select v-model:value="queryForm.timeType" style="width: 33%" placeholder="请选择">
                  <a-select-option :value="1">创建时间</a-select-option>
                  <a-select-option :value="2">首次领取时间</a-select-option>
                  <a-select-option :value="3">最后一次领取时间</a-select-option>
                  <a-select-option :value="4">转为潜在时间</a-select-option>
                  <a-select-option :value="5">转为成交时间</a-select-option>
                  <a-select-option :value="6">更新时间</a-select-option>
                </a-select>
                <cos-range-picker
                  style="width: 67%"
                  v-model:startTime="queryForm.startTime"
                  v-model:endTime="queryForm.endTime"
                />
              </a-input-group>
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <ExportButton
            appId="cos_lbu"
            taskType="334"
            :search="handledQueryParams(queryForm)"
            v-permission="'lbu_road_area_config_export_btn'"
            :totalCount="totalCount"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, record, text,index }">
          <template v-if="column.dataIndex === 'customerName'">
            <div class="flex">
              <router-link
                :to="record.stage === 1 ? `/lbu/salesClue/view?clueId=${record.cosId}` : (record.stage === 2 ? `/lbu/potential/view?cosId=${record.cosId}` : `/lbu/clients/view?cosId=${record.cosId}`)"
                class="ant-table-cell-ellipsis"
                :title="text"
                >{{ text || '--' }}</router-link
              >
            </div>
          </template>
          <template v-if="column.dataIndex === 'channel'">
            <ChannelText appId="cos_lbu" paramCode="lbu_source_channel" :value="text" :desc="record.channelExplain" />
          </template>
          <template v-if="column.dataIndex === 'customerRegion'">
            <CustomerAreaCascaderText appId="cos_lbu" :value="text" />
          </template>
          <!-- <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template> -->
          <template v-if="column.dataIndex === 'customerLabel'">
            <p>{{ record.customerLabel ? record.customerLabel.map((item) => item ).join('、') : '--' }}</p>
          </template>
          <template v-if="column.type === 'money'">
            <p>{{ formatThousandSeparator(text)}}</p>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, onMounted, ref } from 'vue'
import { findByRoadAreaConfig } from '@/api/yuntuSales/roadAreaConfig'
import {
  clientsStatusEnum,
  customerTypeEnum,
  remanentFollowDayTypeEnum,
  customerUnfollowDayTypeEnum,
  tmsCustomerValueEnum, favoriteStatus, clueAndcustomerPhaseEnum, customerAllStatusEnum
} from '@/views/yuntuSales/commonEnum/dataConfig'
import { useRouter, useRoute } from 'vue-router'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { addToFav, cancelToFav, listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { PotentialItem } from '@/typings/api/customerCenter'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
const tableRef = ref()
const totalCount = ref(0)
const selectedRows = ref<PotentialItem[]>([])
const queryForm = reactive({
  sortCollection: 1,
  timeType: 1,
  contact: {
    type: 1
  }
})
const paramCodeData = reactive<{
  lbu_customer_business_area: []
  lbu_sales_category: []
  lbu_cargo_type: []
  lbu_logistics_service_provider: []
  lbu_shipping_channel: []
  lbu_daily_traffic: []
  lbu_sale_platform: []
  lbu_demand_country: []
  lbu_erp_info: []
  lbu_loss_reason: []
  lbu_important: [],
  lbu_customer_grade: []
}>({
  lbu_customer_business_area: [],
  lbu_sales_category: [],
  lbu_cargo_type: [],
  lbu_logistics_service_provider: [],
  lbu_shipping_channel: [],
  lbu_daily_traffic: [],
  lbu_sale_platform: [],
  lbu_demand_country: [],
  lbu_erp_info: [],
  lbu_loss_reason: [],
  lbu_important: [],
  lbu_customer_grade: [],
})
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_customer_business_area',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_sale_platform',
      'lbu_demand_country',
      'lbu_erp_info',
      'lbu_loss_reason',
      'lbu_important',
      'lbu_customer_grade'
    ]
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const handledQueryParams = (params: any) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  const queryForm = handledQueryParams(params)
  findByRoadAreaConfig({
    ...queryForm
  }).then((res) => {
    totalCount.value = res?.data?.totalCount || 0
    callBack(res)
  })
}

const onSelectChange = (selectedRowKeys: string[], rows: PotentialItem[]) => {
  selectedRows.value = rows
}

// const statusEnum = clientsStatusEnum.map((item) => ({
//   name: item.label,
//   value: item.value,
//   color: item.color
// }))
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: 'ID', dataIndex: 'cosId', width: 200 },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: '路区代码', dataIndex: 'roadAreaCode' },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '客户状态', dataIndex: 'status', dicData: customerAllStatusEnum },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '前负责人', dataIndex: 'prevSellerName' },
  { title: '客户标签', dataIndex: 'customerLabel' },
  { title: '客户区域', dataIndex: 'customerRegion' },
  { title: '来源渠道', dataIndex: 'channel', width: 150 },
  { title: '渠道代码', dataIndex: 'tmsChannelCode' },
  { title: '客户类型', dataIndex: 'type', dicData: customerTypeEnum },
  { title: '客户等级', dataIndex: 'grade', dicData: paramCodeData.lbu_customer_grade },
  { title: '未跟进天数', dataIndex: 'unfollowDays' },
  { title: '剩余跟进天数', dataIndex: 'remanentFollowDays' },
  { title: '客户合同地址', dataIndex: 'customerAddress' },
  { title: '备注', dataIndex: 'remark' },
  {
    title: '业务收入等级',
    dataIndex: ['business', 'monthIncome'],
    dicData: paramCodeData.lbu_important
  },
  { title: '年销售GMV（元）', dataIndex: ['business', 'annualSales'], type: 'money', width: 150, sorter: true },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  { title: '首次领取时间', dataIndex: 'firstReceiveTime', width: 190, sorter: true },
  { title: '最后一次领取时间', dataIndex: 'lastReceiveTime', width: 190, sorter: true },
  { title: '转为成交时间', dataIndex: 'turnedTransaction', width: 190, sorter: true },
  { title: '转为潜在时间', dataIndex: 'turnedPotential', width: 190, sorter: true },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true }
])
</script>
<script lang="ts">
export default { name: 'DcCosLbuRoadAreaConfigReport' }
</script>

<style scoped></style>
